import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FiberManualRecord } from '@mui/icons-material';
import { Box, List, ListItem, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material';
import React from 'react';
const MAX_VISIBLE_EVENTS = 3;
export const CalendarCell = React.forwardRef(function CalendarCell(props, ref) {
    const { date, events, birthdays, isCurrentDate, onClick } = props;
    const handleKeyDown = React.useCallback((event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
        }
    }, [onClick]);
    const dayInfo = date.getDayOfTheMonth();
    const dayNumber = dayInfo.dayOfTheMonth + 1;
    const dayName = dayInfo.name;
    const isHoliday = dayInfo.isHoliday;
    const visibleEvents = events.slice(0, MAX_VISIBLE_EVENTS);
    const hiddenEventCount = events.length - visibleEvents.length;
    const hasBirthdays = birthdays.length > 0;
    return (_jsxs(Paper, { ref: ref, elevation: isCurrentDate ? 4 : 1, onClick: onClick, onKeyDown: handleKeyDown, tabIndex: 0, role: "gridcell", "aria-label": `${dayInfo.name}, Day ${dayNumber}${hasBirthdays ? ', has birthdays' : ''}${events.length > 0 ? `, ${events.length} event${events.length > 1 ? 's' : ''}` : ''}`, sx: {
            p: 1,
            minHeight: 100,
            minWidth: 0,
            cursor: 'pointer',
            backgroundColor: isHoliday ? 'action.hover' : 'background.paper',
            '&:hover': {
                backgroundColor: 'action.selected',
            },
            '&:focus': {
                outline: '2px solid',
                outlineColor: 'primary.main',
                outlineOffset: '-2px',
            },
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
        }, children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 0.5,
                }, children: [_jsx(Typography, { variant: "h6", component: "span", sx: {
                            fontWeight: isCurrentDate ? 'bold' : 'normal',
                            color: isCurrentDate ? 'primary.main' : 'text.primary',
                        }, children: dayNumber }), _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [isHoliday && (_jsx(Typography, { variant: "caption", color: "primary", sx: { fontWeight: 'bold' }, children: dayName })), hasBirthdays && (_jsx(Typography, { component: "span", sx: { fontSize: '0.9rem' }, children: "\uD83C\uDF82" }))] })] }), _jsxs(List, { dense: true, disablePadding: true, sx: { flex: 1 }, children: [visibleEvents.map((event) => (_jsxs(ListItem, { disableGutters: true, disablePadding: true, sx: { py: 0 }, children: [_jsx(ListItemIcon, { sx: { minWidth: 16 }, children: _jsx(FiberManualRecord, { sx: { fontSize: 8, color: 'text.secondary' } }) }), _jsx(ListItemText, { primary: event.title, primaryTypographyProps: {
                                    variant: 'caption',
                                    noWrap: true,
                                }, sx: { m: 0 } })] }, event.id))), hiddenEventCount > 0 && (_jsxs(ListItem, { disableGutters: true, disablePadding: true, sx: { py: 0 }, children: [_jsx(ListItemIcon, { sx: { minWidth: 16 }, children: _jsx(FiberManualRecord, { sx: { fontSize: 8, color: 'text.secondary' } }) }), _jsx(ListItemText, { primary: `+${hiddenEventCount} more`, primaryTypographyProps: {
                                    variant: 'caption',
                                    color: 'text.secondary',
                                }, sx: { m: 0 } })] }))] })] }));
});
//# sourceMappingURL=CalendarCell.js.map